import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxScrollTopModule } from 'ngx-scrolltop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { SidebarComponent } from './components/layouts/sidebar/sidebar.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServiceDetailsComponent } from './components/pages/service-details/service-details.component';
import { ProjectsComponent } from './components/pages/projects/projects.component';
import { ProjectDetailsComponent } from './components/pages/project-details/project-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { PartnerComponent } from './components/pages/partner/partner.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { HomeDemoOneComponent } from './components/pages/home-demo-one/home-demo-one.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { HomeDemoThreeComponent } from './components/pages/home-demo-three/home-demo-three.component';
import { HomeDemoFourComponent } from './components/pages/home-demo-four/home-demo-four.component';
import { HomeDemoFiveComponent } from './components/pages/home-demo-five/home-demo-five.component';
import { HomeDemoSixComponent } from './components/pages/home-demo-six/home-demo-six.component';
import { HomeDemoSevenComponent } from './components/pages/home-demo-seven/home-demo-seven.component';
import { HomeDemoEightComponent } from './components/pages/home-demo-eight/home-demo-eight.component';
import { HomeDemoNineComponent } from './components/pages/home-demo-nine/home-demo-nine.component';
import { AboutStyleTwoComponent } from './components/pages/about-style-two/about-style-two.component';
import { TeamStyleTwoComponent } from './components/pages/team-style-two/team-style-two.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { ServicesStyleTwoComponent } from './components/pages/services-style-two/services-style-two.component';
import { ServicesStyleThreeComponent } from './components/pages/services-style-three/services-style-three.component';
import { ProjectsStyleTwoComponent } from './components/pages/projects-style-two/projects-style-two.component';
import { ProjectsStyleThreeComponent } from './components/pages/projects-style-three/projects-style-three.component';
import { ProjectsStyleFourComponent } from './components/pages/projects-style-four/projects-style-four.component';
import { BlogRightSidebarComponent } from './components/pages/blog-right-sidebar/blog-right-sidebar.component';
import { HomeDemoTenComponent } from './components/pages/home-demo-ten/home-demo-ten.component';
import { HomeDemoElevenComponent } from './components/pages/home-demo-eleven/home-demo-eleven.component';
import { HomeDemoTwelveComponent } from './components/pages/home-demo-twelve/home-demo-twelve.component';
import { NavbarStyleTwoComponent } from './components/layouts/navbar-style-two/navbar-style-two.component';
import { FormsModule } from '@angular/forms';
import { BengaliNumberPipe } from './components/pipes/bengali-number.pipe';
import { BengaliMonthPipe } from './components/pipes/bengali-month.pipe';
// import { EmitterService } from './EmitterService';
import { EmitterService } from './EmitterService';
import { HttpClientModule } from '@angular/common/http';
import { AppService } from './app.service';
import { TemplatePageComponent } from './components/pages/template-page/template-page.component';
import { LayoutImageListComponent } from './components/layouts/layout-image-list/layout-image-list.component';
import { LayoutImageSingleComponent } from './components/layouts/layout-image-single/layout-image-single.component';
import { LayoutImageMultipleComponent } from './components/layouts/layout-image-multiple/layout-image-multiple.component';
import { LayoutDocumentListComponent } from './components/layouts/layout-document-list/layout-document-list.component';
import { LayoutDocumentSingleComponent } from './components/layouts/layout-document-single/layout-document-single.component';
import { AdministrationComponent } from './components/pages/administration/administration.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { SafePipe } from './utils/safe.pipe';
import { NoticeComponent } from './components/pages/notice/notice.component';
import { TeachersComponent } from './components/pages/teachers/teachers.component';
import { NavbarStyleThree } from './components/layouts/navbar-style-three/navbar-style-three.component';
import { ContactUsComponent } from './components/pages/contact-us/contact-us.component';
import { EmployeComponent } from './components/pages/employe/employe.component';
import { ModalComponent } from './components/pages/modal/modal.component';
@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    AboutComponent,
    ServicesComponent,
    ServiceDetailsComponent,
    ProjectsComponent,
    ProjectDetailsComponent,
    BlogComponent,
    BlogDetailsComponent,
    FeaturesComponent,
    TeamComponent,
    PricingComponent,
    PartnerComponent,
    NotFoundComponent,
    FaqComponent,
    ContactComponent,
    HomeDemoOneComponent,
    HomeDemoTwoComponent,
    HomeDemoThreeComponent,
    HomeDemoFourComponent,
    HomeDemoFiveComponent,
    ModalComponent,
    HomeDemoSixComponent,
    HomeDemoSevenComponent,
    HomeDemoEightComponent,
    HomeDemoNineComponent,
    AboutStyleTwoComponent,
    TeamStyleTwoComponent,
    LoginComponent,
    RegisterComponent,
    ServicesStyleTwoComponent,
    ServicesStyleThreeComponent,
    ProjectsStyleTwoComponent,
    ProjectsStyleThreeComponent,
    ProjectsStyleFourComponent,
    BlogRightSidebarComponent,
    HomeDemoTenComponent,
    HomeDemoElevenComponent,
    HomeDemoTwelveComponent,
    NavbarStyleTwoComponent,
    NavbarStyleThree,
    BengaliNumberPipe,
    BengaliMonthPipe,
    TemplatePageComponent,
    LayoutImageListComponent,
    LayoutImageSingleComponent,
    LayoutImageMultipleComponent,
    LayoutDocumentListComponent,
    LayoutDocumentSingleComponent,
    AdministrationComponent,
    ImageFolderComponent,
    ImageGalleryComponent,
    VideoFolderComponent,
    VideoGalleryComponent,
    SafePipe,
    NoticeComponent,
    TeachersComponent,
    ContactUsComponent,
    EmployeComponent,
  ],
  //   imports: [BrowserModule, AppRoutingModule, NgxScrollTopModule, FormsModule],
  //   providers: [],
  //   bootstrap: [AppComponent],
  // })
  // export class AppModule {}
  imports: [BrowserModule, AppRoutingModule, NgxScrollTopModule, HttpClientModule, FormsModule, CommonModule, RouterModule],
  providers: [EmitterService, AppService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }

